module.exports = __webpack_public_path__ + "static/img/jc-2.12aca724.webp";